function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2C2F33;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M142.1,402.3h-16.3v-97.3h16.3v11.9c5.8-8.3,15.5-13,26.8-13c1.9,0,3.9,0.1,5.8,0.4l1.2,0.2v17.4l-1.7-0.4 c-2.9-0.6-5.8-0.9-8.7-0.9c-13.7,0-23.3,10.1-23.3,24.6L142.1,402.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M331.6,402.1c16.1,0,27.7-5,37.7-16.2l0.9-1l-10.4-10.8l-1,1c-7.4,7.8-14.2,12.4-27.1,12.4 c-18.1,0-30-11.7-31.2-30.5h73.5l0.1-1.3c0.2-2.7,0.2-5.7,0.2-5.8c0-13.3-4.1-25.4-11.6-34.2c-7.9-9.3-18.7-14.2-31.3-14.2 c-27.9,0-47.3,21.2-47.3,51.6v0.7C284,382.7,303.1,402.1,331.6,402.1z M301.4,342.6c1.6-14.2,14.7-25.6,29.9-25.6 c14.1,0,25.6,11.3,26.3,25.6H301.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 191.8,
  y: 304.9,
  className: "st0",
  width: 16.3,
  height: 97.4
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M264.1,403.4c-5,0-12.4-0.5-18.2-5c-6.4-4.8-9.6-13.3-9.6-25.1v-91h16.3v22.5h21.2v15.4h-21.2v53.1 c0,12.3,4.3,14.7,11.3,14.7c2.8,0.1,5.6-0.1,8.3-0.5l1.6-0.3v15l-1,0.3C270,403.2,267,403.5,264.1,403.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M434.5,403.4c13.2,0.1,25.9-5.1,35.2-14.4c9.6-9.7,14.8-22.9,14.7-36.5c0.2-13.6-5.1-26.8-14.7-36.5 c-19.5-19.2-50.9-19.2-70.4,0c-9.6,9.7-14.8,22.9-14.6,36.5c-0.2,13.7,5.1,26.8,14.7,36.6C408.6,398.4,421.3,403.5,434.5,403.4z  M434.5,317c9.1-0.1,17.8,3.6,24,10.1c6.1,6.5,9.5,15.5,9.5,25.4s-3.4,18.9-9.5,25.4c-12.9,13.2-34.1,13.5-47.4,0.6 c-0.2-0.2-0.4-0.4-0.6-0.6c-6.1-6.5-9.5-15.5-9.5-25.4s3.4-18.9,9.5-25.4C416.7,320.6,425.4,316.9,434.5,317z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M71,403.4c-13.3,0.1-26-5.1-35.5-14.4c-9.6-9.7-14.9-22.8-14.7-36.5c-0.2-13.6,5.1-26.8,14.7-36.5 c9.4-9.3,22.2-14.5,35.5-14.4c14.2,0,26.6,5,35.7,14.4l0.9,0.9l-10,11.9l-1-1.1C90,320.7,81.2,317,71,317 c-9.1-0.1-17.9,3.6-24.2,10.1c-6.2,6.5-9.6,15.5-9.6,25.4s3.4,18.9,9.6,25.4c6.3,6.6,15.1,10.2,24.2,10.1 c10.1,0,18.9-3.7,25.5-10.6l1-1.1l10,11.8l-0.9,0.9C97.6,398.5,85.3,403.4,71,403.4z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M199.9,264.6c-6.9,0.1-12.6-5.5-12.7-12.5c-0.1-6.9,5.5-12.6,12.5-12.7c6.9-0.1,12.6,5.5,12.7,12.5 c0,0,0,0.1,0,0.1C212.4,259,206.8,264.6,199.9,264.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M608.4,403.4c-6.9,0.1-12.6-5.5-12.7-12.5c-0.1-6.9,5.5-12.6,12.5-12.7c6.9-0.1,12.6,5.5,12.7,12.5 c0,0,0,0.1,0,0.1C620.9,397.8,615.3,403.4,608.4,403.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M572.8,384.9h-33.2c-8.6,0-15.5-7-15.5-15.6v-97.8c0-14.1-11.4-25.4-25.4-25.4H235.7v11.3h261.5 c8.6,0,15.5,7,15.5,15.5c0,0,0,0,0,0v97.8c0,14.1,11.4,25.5,25.4,25.5h34.6V384.9z"
});

var SvgCriteo = function SvgCriteo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.7598,
    y1: 399.8284,
    x2: 659.9106,
    y2: 399.8284,
    gradientTransform: "matrix(1 0 0 -1 0 651.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F68C21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F16324"
    }
  })), _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.7598,
    y1: 261.0211,
    x2: 659.9106,
    y2: 261.0211,
    gradientTransform: "matrix(1 0 0 -1 0 651.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F68C21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F16324"
    }
  })), _ref10, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.7598,
    y1: 330.6572,
    x2: 659.9106,
    y2: 330.6572,
    gradientTransform: "matrix(1 0 0 -1 0 651.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F68C21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F16324"
    }
  })), _ref11)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCriteo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/criteo.89056485.svg";
export { ForwardRef as ReactComponent };